import { Warning } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import { FC, useEffect, useRef } from 'react';
import { useNewTransaction } from './new-transaction.context';

const WarningAdornment: FC = () => {
  const { formRef } = useNewTransaction();

  let inputRef = useRef<HTMLInputElement | null>();

  useEffect(() => {
    if (document.body.isSameNode(document.activeElement)) {
      inputRef.current?.reportValidity();
    }
  }, []);

  return (
    <InputAdornment
      className="z-1"
      position="end"
      ref={ref => {
        inputRef.current = ref?.parentElement?.querySelector('input');
      }}
      onMouseEnter={() => (inputRef.current ?? formRef.current)?.reportValidity()}
      onClick={() => (inputRef.current ?? formRef.current)?.reportValidity()}
    >
      <Warning />
    </InputAdornment>
  );
};

export default WarningAdornment;
